// react library imports
import { CaretRight, CaretLeft } from 'phosphor-react';

// style imports
import './HorizontalCalender.css';

const HorizontalCalender = ({generateCalendar, setStartDate, startDate}) => {
    // handle previous date
    const handlePrevClick = () => {
        const newStartDate = new Date(startDate);
        newStartDate.setDate(startDate.getDate() - 7);
        setStartDate(newStartDate);
    };
    
    // handle next date
    const handleNextClick = () => {
        const newStartDate = new Date(startDate);
        newStartDate.setDate(startDate.getDate() + 7);
        setStartDate(newStartDate);
    };
  return (
    <div className='horizontal_calender mues_row_space_between mues_grey_I'>
        <CaretLeft className="horizontal_calender_icon" weight='bold'
        onClick={handlePrevClick}/>
        <div className='horizontal_calender_container'>
            {generateCalendar()}
        </div>
        <CaretRight className="horizontal_calender_icon" weight='bold'
        onClick={handleNextClick}/>
    </div>
  )
}

export default HorizontalCalender